class BxfCheckboxConstants {
    static COMPONENT_NAME = 'bxf-checkbox';
    static STRING = {
        CONTAINER: 'bxf-checkbox__container',
        CONTAINER_LARGE: 'bxf-checkbox__container-large',
        DISABLED: 'bxf-checkbox--disabled',
        READONLY: 'bxf-checkbox--readonly',
        CHECKBOX: 'bxf-checkbox__checkbox',
        CHECKBOX_REGULAR: 'bxf-checkbox__regular',
        CHECKMARK_MIXED: 'checkbox-mixed-state-2',
        CHECKMARK: 'checkmark',
        LABEL: 'bxf-checkbox__label',
        LABEL_DISABLED: 'disabled',
        LABEL_CONTAINER: 'bxf-checkbox__label-container',
        MATCH_STYLE: 'bxf-checkbox__match',
        CHECKBOX_VALIDATION_ERROR: 'bxf-checkbox__validation-error',
        CHECKBOX_VALIDATION_WARNING: 'bxf-checkbox__validation-warning',
        LABEL_SECONDARY_CONTAINER: 'bxf-checkbox__label-secondary-container',
        LABEL_SECONDARY_CONTAINER_RIGHT: 'bxf-checkbox__label-secondary-container--right',
        SECONDARY_LABEL: 'bxf-checkbox__secondary-label',
        SECONDARY_LABEL_GROUP: 'bxf-checkbox-group__secondary-label',
        SECONDARY_LABEL_RIGHT: 'bxf-checkbox__secondary-label--right',
    };
}

export { BxfCheckboxConstants as B };
